import React, { useEffect, useRef, useState, } from 'react'
import HtmlParser from 'react-html-parser';
import { Link, useHistory, useLocation } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';
import Menu from '../main/Menu';
import {
    responseGet, globalSettings, globalSettingsPassword, styles, validateEmail, sendMessageCloseCurrentWindowAsync, isUndNullEmp, languageObjGet,
} from '../../helpers/settings';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'Login';

const { icons, labels, messages, } = globalSettings;

export default function Login({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const history = useHistory();
    const location = useLocation();
    //const previusObjUrl = location?.state?.from;
    const previusObjUrl = !isUndNullEmp({ data: location, subMethod: currentMethod })?.result &&
        !isUndNullEmp({ data: location?.state, subMethod: currentMethod, })?.result &&
        !isUndNullEmp({ data: location?.state?.from, subMethod: currentMethod })?.result ? location?.state?.from : '/';

    const [formData, setFormData] = useState({});
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const recaptchaRef = useRef(ReCAPTCHA);
    const urlStop = '#nothing';
    const controls = {
        buttons: {
            // home: {
            //     className: 'btn btn-sm btn-outline-success',
            //     id: 'btnHome',
            // },
            login: {
                //className: 'btn btn-sm btn-outline-primary mx-1',
                //className: 'btn btn-sm btn-outline-primary float-right',
                className: 'btn btn-outline-primary float-right',
                id: 'btnLogin',
            },
        },
        checkBox: {
            remenberMe: {
                attributes: {
                },
                id: 'chkRemenberMe',
            },
        },
        icons: {
            login: {
                id: 'iconLogin',
                className: icons?.powerOff,
            },
        },
        inputs: {
            email: {
                id: 'inputEmail',
            },
            password: {
                id: 'inputPassword',
            },
        },
        spinners: {
            login: {
                id: 'spLogin',
                className: '',
            }
        },
        urls: {
            forgotYourPassword: {
                id: 'urlForgotYourPassword',
                className: 'btn-link',
            },
            reCaptchaPrivaciConditions: {
                id: 'urlReCaptchaPrivaciConditions',
                className: '',
            },
            userRegister: {
                id: 'urlRequestAccount',
                className: '',
            },
            registerStatus: {
                id: 'urlStatusRegister',
                className: '',
            },
        },
    };
    //#endregion variables

    //#region methods
    const formDataSetAsync = async ({ type = '', value = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setFormData({ ...formData, [type]: value, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}</br>`;
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async () => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: formData?.email, subMethod: currentMethod, })?.result) {
                setEmailError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (!validateEmail({ email: formData?.email })) {
                setEmailError(messages?.youMustEnterValidEmail?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: formData?.password, subMethod: currentMethod, })?.result) {
                setPasswordError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (formData?.password?.trim()?.length < globalSettingsPassword?.minLength) {
                setPasswordError(messages?.youMustEnterValidPassword?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}</br>`;
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const initializeErrorsAsync = async () => {
        const currentMethod = 'initializeErrorsAsync';
        let response = responseGet();
        try {
            setEmailError('');
            setPasswordError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}</br>`;
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const loginAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'loginAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            setShowPassword(false);
            response = await initializeErrorsAsync();
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion initialize

            //#region Form validate
            response = await formDataValidateAsync();
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion Form validate

            //sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers.thirtySeconds, false, true, null, '');
            controlsStatusSet({ processType: 1, subMethod: currentMethod });

            //#region get reCAPTCHA token
            const recaptchaToken = await recaptchaRef.current.executeAsync();
            recaptchaRef?.current?.reset();
            //#endregion get reCAPTCHA token

            //#region Loggin
            //await new Promise(resolve => setTimeout(resolve, 4000));
            //await awaitDelay({delayTimer: 4000});
            response = await auth?.loginAsync({
                email: formData?.email,
                password: formData?.password,
                rememberMe: formData?.rememberMe,
                saveUser: true,
                languageId: languageObj?.id,
                recaptchaToken: recaptchaToken,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            history.push(previusObjUrl || '/');
            //#endregion Loggin

            //sendMessage(-2, '', 0, false, false, null, '');
            controlsStatusSet({ processType: 0, subMethod: currentMethod });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataGetAsync = async () => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            // if(auth?.isLoged()){
            //     history.push('/');
            // }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}</br>`;
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.login?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.login?.id}`)?.removeClass();
                    //$(`#${controls?.buttons?.home?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.login?.id}`)?.removeClass();

                    $(`#${controls?.icons?.login?.id}`)?.addClass(controls?.icons?.login.className);
                    $(`#${controls?.buttons?.login?.id}`)?.addClass(controls?.buttons?.login?.className);
                    //$(`#${controls?.buttons?.home?.id}`)?.addClass(controls?.buttons?.home?.className);
                    $(`#${controls?.spinners?.login?.id}`)?.addClass(controls?.spinners?.login.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.buttons?.login?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                    //$(`#${controls?.buttons?.home?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                    $(`#${controls?.icons?.login?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));

            $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code
            $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
                'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
                'target': (processType !== 0 ? '' : '_blank'),
            });

            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;

            if (processType !== 0) {
                $(`#${controls?.buttons?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                //$(`#${controls?.buttons?.home?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync();
    }, []); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName='home' />
            <div className='content-wrapper'>
                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.login?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.login?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <br />

                        <div className='login-box' style={styles?.loginBox}>
                            {/* /.login-logo */}
                            <div className='card card-outline card-primary shadow-lg'>

                                <div className='card-header'>
                                    <h6><img src={globalSettings?.images.userLogin} alt='userLogin' style={styles?.cardHeaderLogo} /> - {labels?.login?.[languageObj?.id]}</h6>
                                </div>

                                <div className='card-body'>

                                    <p className='login-box-msg'>{labels?.signInToStartYourSession?.[languageObj?.id]}</p>

                                    <form onSubmit={(e) => loginAsync({ e: e, subMethod: 'form - onSubmit' })}
                                        method='post'>
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input id={controls?.inputs?.email?.id}
                                                    className='form-control'
                                                    placeholder={labels?.email?.[languageObj?.id]}
                                                    //autoFocus
                                                    onChange={(e) => formDataSetAsync({ type: 'email', value: e?.target?.value })}
                                                    onFocus={() => setEmailError('')}
                                                    value={!isUndNullEmp({ data: formData?.email, subMethod: currentMethod, })?.result ? formData.email : ''}
                                                    tooltip='tooltip'
                                                    title={labels?.email?.[languageObj?.id]}
                                                    type='email' />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={icons?.envelope} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(emailError)}</div>
                                        </div>
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input id={controls?.inputs?.password?.id}
                                                    type={showPassword ? 'text' : 'password'}
                                                    className='form-control'
                                                    placeholder={labels?.password?.[languageObj?.id]}
                                                    onChange={(e) => formDataSetAsync({ type: 'password', value: e?.target?.value, })}
                                                    onFocus={() => setPasswordError('')}
                                                    value={!isUndNullEmp({ data: formData?.password, subMethod: currentMethod, })?.result ? formData.password : ''}
                                                    tooltip='tooltip'
                                                    title={labels?.password?.[languageObj?.id]} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text' type='button'>
                                                        {/* <span className={showPassword ? 'far fa-eye ipassword ipassword' : 'far fa-eye-slash ipassword ipassword'} onClick={(e) => setShowPassword(!showPassword)} /> */}
                                                        <span className={showPassword ? icons?.eyeIpasswordIpassword : icons?.eyeSlashIpasswordIpassword} onClick={(e) => setShowPassword(!showPassword)} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(passwordError)}</div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-8'>
                                                <div className='icheck-primary'>
                                                    <input id={controls?.checkBox?.remenberMe?.id}
                                                        type='checkbox'
                                                        onChange={(e) => formDataSetAsync({ type: 'rememberMe', value: e?.currentTarget?.checked, })}
                                                        onClick={(e) => formDataSetAsync({ type: 'rememberMe', value: e?.currentTarget?.checked, })} />
                                                    <label htmlFor={controls?.checkBox?.remenberMe?.id}>
                                                        {labels?.rememberMe?.[languageObj?.id]}
                                                    </label>
                                                </div>
                                            </div>
                                            {/* /.col */}
                                            <div className='col-4'>
                                                <button id={controls?.buttons?.login?.id}
                                                    type='submit'
                                                    className={controls?.buttons?.login?.className}
                                                    tooltip='tooltip'
                                                    title={labels?.send?.[languageObj?.id]}>
                                                    <i id={controls?.icons?.login?.id} className={icons?.powerOff} /> <span id={controls?.spinners?.login?.id} className='' aria-hidden='true'></span>
                                                </button>
                                            </div>
                                            {/* /.col */}
                                        </div>
                                    </form>

                                    <div hidden>
                                        <ReCAPTCHA className='g-recaptcha'
                                            sitekey={globalSettings?.app?.reCAPTCHA?.reCAPTCHASiteKey}
                                            size='invisible'
                                            ref={recaptchaRef} />
                                    </div>

                                    {/* <div className='social-auth-links text-center mt-2 mb-3'>
                                    <a href='#' className='btn btn-block btn-primary'>
                                        <i className='fab fa-facebook mr-2' /> Sign in using Facebook
                                    </a>
                                    <a href='#' className='btn btn-block btn-danger'>
                                        <i className='fab fa-google-plus mr-2' /> Sign in using Google+
                                    </a>
                                </div> */}

                                    {/* /.social-auth-links */}
                                    <div>
                                        <i className={icons?.fasFa?.lok} />{' '}<a id={controls?.urls?.forgotYourPassword?.id} href={globalSettings?.app?.backend?.urlForgotPassword} className='btn-link'>{labels?.forgotYourPassword?.[languageObj?.id]}</a>
                                    </div>
                                    <div>
                                        <i className='fas fa-user-check' />{' '}<a id={controls?.urls?.userRegister?.id} href={globalSettings?.app?.backend?.urlUserRegister} className='btn-link'>{labels?.registerNewMembership?.[languageObj?.id]}</a>
                                    </div>
                                    <div>
                                        <i className={icons?.userClock} />{' '}<a id={controls?.urls?.registerStatus?.id} href={globalSettings?.app?.backend?.urlRegisterStatus} className='btn-link'>{labels?.checkRegistrationStatus?.[languageObj?.id]}</a>
                                    </div>

                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}

                        </div>
                        {/* /.login-box */}

                        <div className='text-muted text-center text-small'>
                            <p>
                                <small>{labels?.protectedByReCAPTCHA?.[languageObj?.id]} - <a id={controls?.urls?.reCaptchaPrivaciConditions?.id} target='_blank' href={globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions} rel='noreferrer'>{labels?.privacyAndConditions?.[languageObj?.id]}</a></small>
                            </p>
                        </div>

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>
        </div>
    )
}